


























import Vue from "vue";
import Component from "vue-class-component";
import EventBus from "front-component/EventBus";
import _ from "lodash";
import {Prop} from "vue-property-decorator";

const components = { };

@Component({ components })
export default class List extends Vue {
    @Prop({ default: [] }) public orders!: object[];
    @Prop(String) protected label!: string;

    private sortBy(): void {
        let orderBy = "";

        if ("DESC" === _.get(this.orders, this.label, "")) {
            orderBy = "ASC";
        } else if ("ASC" === _.get(this.orders, this.label, "")) {
            orderBy = "";
        } else if ("" === _.get(this.orders, this.label, "")) {
            orderBy = "DESC";
        }
        EventBus.$emit("update-order", _.set({}, this.label, orderBy));
    }

    private get currentOrder(): string {
        return _.get(this.orders, this.label, "");
    }

    public getStyle(order: string) {
        return {
            color: order === this.currentOrder ? "#1989fa" : "grey",
            position: "absolute",
            left: "2px",
        };
    }
}
